import { QuestionListRow } from "features/Surveys/CustomSurveys/components/QuestionsList/QuestionListRow"
import * as React from "react"
import { t } from "ttag"
import * as Styles from "./QuestionsList.styles"
import { CustomQuestion, CustomQuestionsPagingInfoState } from "models/CustomQuestions"
import config from "config/business"
import { CenteredLoader, PagedNavigation, Select, SelectOptionProps } from "@humanpredictiveintelligence/myqvt-library"

export const QuestionsList: React.FC<QuestionsListProps> = (props) => {
  const pagesCount = Math.ceil(props.count / props.pagingInfo.pageSize) || 1

  return (
    <Styles.Container>
      <Styles.Header>
        <Styles.StatusCell>{t`Question status`}</Styles.StatusCell>
        <Styles.QuestionCell>{t`Question title`}</Styles.QuestionCell>
        <Styles.ChoicesCountCell>{t`Number of choices`}</Styles.ChoicesCountCell>
        <Styles.ActionsCell/>
      </Styles.Header>

      <Styles.Rows>
        {renderList(props.questions, props.loading)}
      </Styles.Rows>

      <Styles.Pagination>
        <Select
          defaultItem={false}
          onChange={updatePageSize}
          options={config.survey.customQuestions.pageSizes.map(pageSize => ({
            value: pageSize,
            wording: pageSize.toString(),
          }))}
          value={props.pagingInfo.pageSize}
          aria-label="questions-pagination"
        />

        <PagedNavigation
          isLoadingData={props.loading}
          numberOfPages={pagesCount}
          onNavigate={updateCurrentPage}
          page={props.pagingInfo.currentPage}
        />
      </Styles.Pagination>
    </Styles.Container>
  )

  function renderList(questions: CustomQuestion[], isLoading: boolean) {
    if (isLoading && questions.length === 0) {
      return <CenteredLoader isTransparent/>
    }

    if (questions.length === 0) {
      return <Styles.EmptyQuestionsMessage>{t`The list is empty...`}</Styles.EmptyQuestionsMessage>
    }

    return questions.map(question => (
      <QuestionListRow
        key={question.id}
        question={question}
        onEdit={() => props.onEditQuestion(question)}
        onDelete={() => props.onDeleteQuestion(question)}
      />
    ))
  }

  function updateCurrentPage(newPage: number) {
    props.onPagingInfoChange(currentPagingInfo => ({
      ...currentPagingInfo,
      currentPage: newPage,
    }))
  }

  function updatePageSize(option: SelectOptionProps | undefined) {
    props.onPagingInfoChange({
      currentPage: 1,
      pageSize: option?.value as number,
    })
  }
}

export interface QuestionsListProps
  extends CustomQuestionsPagingInfoState {
  questions: CustomQuestion[],
  count: number,
  loading: boolean,
  onEditQuestion: (question: CustomQuestion) => void,
  onDeleteQuestion: (question: CustomQuestion) => void,
}
